module.exports = __webpack_public_path__ + "img/progress_055.2c9c772d.png";